import React, { useState, useEffect, useCallback } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  createOtpVerifyRequest,
  createOtpRequest,
  getRequestTypeStage,
  getRequestTypeDocs,
  addMobileOrEmailKra,
} from "designs/v1/pages/ModifyKyc/services";
import { validateOnNumber } from "utils";

const EmailOtpVerify = ({
  stageScreen,
  setStageScreen,
  setStep,
  isContinue,
  setIsContinue,
  isLoading,
  setIsLoading,
  activeUserDetail,
}) => {
  const dummyEmailOtp = "du_123";
  const initialValues = {
    // old_phone: activeUserDetail.phone?.length !== 12 ? dummyEmailOtp : "",
    // old_email: activeUserDetail.email?.includes("@nomail") ? dummyEmailOtp : "",
    modification_email: "",
  };
  const validationSchema = Yup.object().shape({
    // old_phone: "",
    // old_email: "",
    modification_email: "",
  });
  const [isValidOtp, setIsValidOtp] = useState({
    // old_phone: activeUserDetail.phone?.length !== 12 ?? false,
    // old_email: activeUserDetail.email?.includes("@nomail") ?? false,
    modification_email: false,
  });
  const [oldPhoneOtp, setOldPhoneOtp] = useState(60);
  const [oldEmailOtp, setOldEmailOtp] = useState(60);
  const [modifyEmailOtp, setModifyEmailOtp] = useState(60);

  useEffect(() => {
    let intervalId;
    if (oldPhoneOtp > 0 && !isValidOtp.old_phone) {
      intervalId = setInterval(() => {
        setOldPhoneOtp((counter) => counter - 1);
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [oldPhoneOtp, isValidOtp]);
  useEffect(() => {
    let intervalId;
    if (oldEmailOtp > 0 && !isValidOtp.old_email) {
      intervalId = setInterval(() => {
        setOldEmailOtp((counter) => counter - 1);
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [oldEmailOtp, isValidOtp]);
  useEffect(() => {
    let intervalId;
    if (modifyEmailOtp > 0 && !isValidOtp.modification_email) {
      intervalId = setInterval(() => {
        setModifyEmailOtp((counter) => counter - 1);
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [modifyEmailOtp, isValidOtp]);

  useEffect(() => {
    if (
      // isValidOtp.old_phone &&
      // isValidOtp.old_email &&
      isValidOtp.modification_email
    ) {
      setIsContinue(false);
      handleKraApi();
    }
  }, [isValidOtp]);

  const verifyOtp = useCallback(
    async (type, value) => {
      const payload = {
        request_type: stageScreen,
        doc_name: localStorage.getItem("EmailRequestNumber"),
        type: type,
        otp: value,
      };
      setIsLoading(true);
      try {
        const resp = await createOtpVerifyRequest(payload);
        console.log("resp", resp);
        setIsLoading(false);
        setIsValidOtp({
          ...isValidOtp,
          [type]: true,
        });
      } catch (error) {
        const { data } = error.response || {};
        toast.error(
          data.message?.message || "Internal server error!"
        );
        setIsLoading(false);
      }
    },
    [stageScreen, isValidOtp, setIsLoading]
  );

  useEffect(() => {
    if (activeUserDetail.phone?.length !== 12) {
      verifyOtp("old_phone", dummyEmailOtp);
    }
  }, [activeUserDetail.phone]);

  useEffect(() => {
    if (activeUserDetail.email?.includes("@nomail")) {
      verifyOtp("old_email", dummyEmailOtp);
    }
  }, [activeUserDetail.email]);

  const handleSubmit = async () => {};

  const resendOtp = async () => {
    const payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("EmailRequestNumber"),
    };
    try {
      const resp = await createOtpRequest(payload);
      console.log("resp", resp);
    } catch (error) {
      const { data } = error.response || {};
      toast.error(
        data.message?.message || "Internal server error!"
      );
    }
  };

  const handleKraApi = async (value) => {
    const payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("EmailRequestNumber"),
      ...value,
    };
    setIsLoading(true);
    try {
      await addMobileOrEmailKra({
        request_type: stageScreen,
        document_name: localStorage.getItem("EmailRequestNumber"),
        pan_number: activeUserDetail.poi?.[0]?.pan_number,
        dob: activeUserDetail.poi?.[0]?.dob?.split("-").reverse().join("-"),
      });
      setIsLoading(false);
      const requestTypes = getRequestTypeStage();
      const requestTypesDocs = getRequestTypeDocs() || [];
      requestTypesDocs.push(payload.doc_name);
      if (requestTypes && requestTypes.length > 0) {
        requestTypes.shift();
        localStorage.setItem("RequestTypeStage", JSON.stringify(requestTypes));
        localStorage.setItem(
          "RequestTypeDocs",
          JSON.stringify(requestTypesDocs)
        );
        Swal.fire({
          title: "Email Modification Request Saved. Thank You..!",
          icon: "success",
          showCloseButton: false,
          showConfirmButton: false,
          timer: 3000,
        });
        if (requestTypes.length === 0) {
          setTimeout(async () => {
            await setStageScreen("MultipleRequestTypes");
          }, 3000);
          return;
        }
        setTimeout(async () => {
          await setStageScreen(requestTypes[0]);
        }, 3000);
        return;
      }
      setStep("EmailModificationReview");
    } catch (error) {
      const { data } = error.response || {};
      toast.error(
        data.message?.message || "Internal server error!"
      );
      setIsLoading(false);
    }
  };

  return (
    <>
      <Title title="Email OTP verification" />
      <div className="row">
        <div className="col-md-9">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ setFieldValue }) => (
                  <Form>
                    {/* {activeUserDetail.phone?.length === 12 && (
                      <div className="form-group my-2">
                        <label className="py-1">Mobile OTP</label>
                        <Field
                          type="text"
                          name="old_phone"
                          placeholder="Mobile OTP"
                          className="form-control"
                          maxLength="6"
                          onChange={(e) => {
                            setFieldValue("old_phone", e.target.value);
                            if (e.target.value.length === 6) {
                              verifyOtp("old_phone", e.target.value);
                            }
                          }}
                          onKeyPress={validateOnNumber}
                          disabled={isValidOtp["old_phone"]}
                          autoFocus={true}
                        />
                        {!isValidOtp["old_phone"] && (
                          <button
                            type="button"
                            className="btn btn-sm mt-1"
                            onClick={() => {
                              setFieldValue("old_phone", "");
                              setIsValidOtp({
                                ...isValidOtp,
                                old_phone: false,
                              });
                              setOldPhoneOtp(60);
                              resendOtp();
                            }}
                            onKeyPress={validateOnNumber}
                            disabled={oldPhoneOtp > 0}
                          >
                            Resend OTP
                            {oldPhoneOtp > 0
                              ? " after " + oldPhoneOtp + " second"
                              : ""}
                          </button>
                        )}
                      </div>
                    )} */}
                    {/* {!activeUserDetail.email?.includes("@nomail") && (
                      <div className="form-group my-2">
                        <label className="py-1">Email OTP</label>
                        <Field
                          type="text"
                          name="old_email"
                          placeholder="Email OTP"
                          className="form-control"
                          maxLength="6"
                          onChange={(e) => {
                            setFieldValue("old_email", e.target.value);
                            if (e.target.value.length === 6) {
                              verifyOtp("old_email", e.target.value);
                            }
                          }}
                          onKeyPress={validateOnNumber}
                          disabled={isValidOtp["old_email"]}
                        />
                        {!isValidOtp["old_email"] && (
                          <button
                            type="button"
                            className="btn btn-sm mt-1"
                            onClick={() => {
                              setFieldValue("old_email", "");
                              setIsValidOtp({
                                ...isValidOtp,
                                old_email: false,
                              });
                              setOldEmailOtp(60);
                              resendOtp();
                            }}
                            disabled={oldEmailOtp > 0}
                          >
                            Resend OTP
                            {oldEmailOtp > 0
                              ? " after " + oldEmailOtp + " second"
                              : ""}
                          </button>
                        )}
                      </div>
                    )} */}
                    <div className="form-group my-2">
                      <label className="py-1">New Email OTP</label>
                      <Field
                        type="text"
                        name="modification_email"
                        placeholder="Modification Email OTP"
                        className="form-control"
                        maxLength="6"
                        onChange={(e) => {
                          setFieldValue("modification_email", e.target.value);
                          if (e.target.value.length === 6) {
                            verifyOtp("modification_email", e.target.value);
                          }
                        }}
                        disabled={isValidOtp["modification_email"]}
                      />
                      {!isValidOtp["modification_email"] && (
                        <button
                          type="button"
                          className="btn btn-sm mt-2"
                          onClick={() => {
                            setFieldValue("modification_email", "");
                            setIsValidOtp({
                              ...isValidOtp,
                              modification_email: false,
                            });
                            setModifyEmailOtp(60);
                            resendOtp();
                          }}
                          disabled={modifyEmailOtp > 0}
                        >
                          Resend OTP
                          {modifyEmailOtp > 0
                            ? " after " + modifyEmailOtp + " second"
                            : ""}
                        </button>
                      )}
                    </div>
                    <div className="d-flex form-group mt-2">
                      <div className="">
                        <Button
                          title="Back"
                          type="button"
                          handleClick={() => {
                            setStep(
                              isContinue
                                ? "CheckPrevRequest"
                                : "EmailModification"
                            );
                            setIsContinue(false);
                          }}
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailOtpVerify;
